(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-carrousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('carousel-component')) {
    class CarouselComponent extends HTMLElement {
      constructor() {
        super();
        this.track = null;
        this.slides = [];
        this.dotsContainer = null;
        this.prevBtn = null;
        this.nextBtn = null;
        this.dots = [];
        this.resizeObserver = null;

        this.handlePrevClick = this.handlePrevClick.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
      }

      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dotsContainer = this.querySelector('[data-dots]');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');

        this.buildDots();
        this.bindEvents();
        this.setupResizeObserver();
        this.updateControls();
      }

      disconnectedCallback() {
        this.unbindEvents();
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
          this.resizeObserver = null;
        }
      }

      buildDots() {
        if (!this.dotsContainer) return;

        this.dotsContainer.innerHTML = '';
        this.dots = this.slides.map((_, index) => {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ef-carousel__dot';
          btn.setAttribute('aria-label', 'Go to slide ' + (index + 1));
          btn.addEventListener('click', () => {
            var slide = this.slides[index];
            this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          });
          this.dotsContainer.appendChild(btn);
          return btn;
        });
      }

      bindEvents() {
        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', this.handlePrevClick);
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', this.handleNextClick);
        }
        if (this.track) {
          this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        }
      }

      unbindEvents() {
        if (this.prevBtn) {
          this.prevBtn.removeEventListener('click', this.handlePrevClick);
        }
        if (this.nextBtn) {
          this.nextBtn.removeEventListener('click', this.handleNextClick);
        }
        if (this.track) {
          this.track.removeEventListener('scroll', this.handleScroll);
        }
      }

      handlePrevClick() {
        var slideWidth = this.slides[0].clientWidth;
        var gap = parseFloat(getComputedStyle(this).getPropertyValue('--carousel-gap')) || 0;
        this.track.scrollBy({ left: -(slideWidth + gap), behavior: 'smooth' });
      }

      handleNextClick() {
        var slideWidth = this.slides[0].clientWidth;
        var gap = parseFloat(getComputedStyle(this).getPropertyValue('--carousel-gap')) || 0;
        this.track.scrollBy({ left: slideWidth + gap, behavior: 'smooth' });
      }

      handleScroll() {
        this.updateControls();
      }

      getActiveIndex() {
        if (!this.track || !this.slides.length) return 0;
        var scrollLeft = this.track.scrollLeft;
        var closestIndex = 0;
        var closestDistance = Infinity;

        this.slides.forEach((slide, index) => {
          var distance = Math.abs(slide.offsetLeft - scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      setupResizeObserver() {
        if (typeof ResizeObserver === 'undefined' || !this.track) return;

        this.resizeObserver = new ResizeObserver(() => {
          this.updateControls();
        });

        this.resizeObserver.observe(this.track);
      }

      updateControls() {
        if (!this.track) return;
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        var scrollLeft = this.track.scrollLeft;
        var scrollWidth = this.track.scrollWidth;
        var clientWidth = this.track.clientWidth;
        var maxScroll = scrollWidth - clientWidth;

        // Update dots (mobile only) - calculate activeIndex from scroll position
        if (isMobile && this.dots && this.dots.length) {
          var activeIndex = this.getActiveIndex();
          this.dots.forEach((dot, i) => {
            if (i === activeIndex) {
              dot.classList.add('ef-carousel__dot--active');
            } else {
              dot.classList.remove('ef-carousel__dot--active');
            }
          });
        }

        // Update arrows - same logic for both: check scroll position
        if (this.prevBtn) {
          this.prevBtn.disabled = scrollLeft <= 1;
        }
        if (this.nextBtn) {
          this.nextBtn.disabled = scrollLeft >= maxScroll - 1;
        }
      }
    }

    customElements.define('carousel-component', CarouselComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const heroVideo = document.querySelector('.hero-video');
    if (!heroVideo) return;

    const video = heroVideo.querySelector('.hero-video__video');
    const poster = heroVideo.querySelector('.hero-video__poster');

    if (!video) return;

    // Optimize video loading for above-the-fold hero
    // Start with preload="metadata" to avoid blocking initial page load,
    // then upgrade to full load once page is ready
    function loadVideo() {
      if (video.dataset.loaded) return;

      // Set preload to 'auto' to start downloading full video
      video.preload = 'auto';

      // Try to play video
      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // Video is playing, hide poster
            video.classList.add('hero-video__video--playing');
            video.dataset.loaded = 'true';
          })
          .catch(() => {
            // Autoplay failed (e.g., user preference), keep poster visible
            // Video will still load in background
            video.dataset.loaded = 'true';
          });
      }
    }

    // Hide poster when video starts playing
    video.addEventListener('playing', () => {
      video.classList.add('hero-video__video--playing');
      if (poster) {
        poster.style.opacity = '0';
      }
    });

    // Show poster if video fails to load
    video.addEventListener('error', () => {
      video.classList.remove('hero-video__video--playing');
      if (poster) {
        poster.style.opacity = '1';
      }
    });

    // Since hero is above-the-fold, load video as soon as page is ready
    // Use requestIdleCallback if available to not block critical rendering,
    // otherwise load after a short delay
    function startVideoLoad() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(loadVideo, { timeout: 500 });
      } else {
        // Fallback: small delay to let critical resources load first
        setTimeout(loadVideo, 100);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startVideoLoad);
    } else {
      startVideoLoad();
    }

    // Handle Shopify theme editor
    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        const sectionVideo = event.target.querySelector('.hero-video__video');
        if (sectionVideo) {
          setTimeout(() => {
            sectionVideo.preload = 'auto';
            sectionVideo.play().catch(() => {});
          }, 100);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-sweeper"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const wrapper = document.querySelector('.image-sweeper__wrapper');
    const slider = document.querySelector('#image-sweeper-slider');
    const leftImage = document.querySelector('#image-sweeper-left');

    if (!wrapper || !slider || !leftImage) return;

    let isDragging = false;
    let startX = 0;
    let currentX = 0;

    function updateSlider(position) {
      const wrapperRect = wrapper.getBoundingClientRect();
      const percentage = Math.max(0, Math.min(100, (position / wrapperRect.width) * 100));

      slider.style.left = percentage + '%';
      // Use clip-path to reveal the left portion, keeping image at 100% width
      const clipRight = 100 - percentage;
      leftImage.style.clipPath = `inset(0 ${clipRight}% 0 0)`;
    }

    function handleStart(e) {
      isDragging = true;
      wrapper.classList.add('is-dragging');
      const clientX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
      const wrapperRect = wrapper.getBoundingClientRect();
      startX = clientX - wrapperRect.left;
      currentX = startX;
      updateSlider(startX);
      e.preventDefault();
    }

    function handleMove(e) {
      if (!isDragging) return;
      const clientX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
      const wrapperRect = wrapper.getBoundingClientRect();
      currentX = clientX - wrapperRect.left;
      updateSlider(currentX);
      e.preventDefault();
    }

    function handleEnd() {
      isDragging = false;
      wrapper.classList.remove('is-dragging');
    }

    // Mouse events
    wrapper.addEventListener('mousedown', handleStart);
    document.addEventListener('mousemove', handleMove);
    document.addEventListener('mouseup', handleEnd);

    // Touch events
    wrapper.addEventListener('touchstart', handleStart);
    document.addEventListener('touchmove', handleMove);
    document.addEventListener('touchend', handleEnd);

    // Initialize at 50%
    const wrapperRect = wrapper.getBoundingClientRect();
    updateSlider(wrapperRect.width * 0.5);
  })();

  } catch(e) { console.error(e); }
})();
})();
